<br />
<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="title-color">
            <h1>CREAR O EDITAR SEGUIMIENTO</h1>
        </div>
        <br />
        <section class="table-container mat-elevation-z1" tabindex="0">
            <div>
                <table
                    mat-table
                    class="w-full"
                    [dataSource]="
                        incidenteSeleccionado ? [incidenteSeleccionado] : []
                    "
                >
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef>Id</th>
                        <td mat-cell *matCellDef="let incidente">
                            {{ incidente.id }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="violenceType">
                        <th mat-header-cell *matHeaderCellDef>
                            Tipo_de_violencia
                        </th>
                        <td mat-cell *matCellDef="let incidente">
                            <ng-container
                                *ngIf="
                                    incidente.violence?.length;
                                    else noViolence
                                "
                            >
                                <ul class="list-none p-0 m-0">
                                    <li *ngFor="let v of incidente.violence">
                                        {{ v.name }}
                                    </li>
                                </ul>
                            </ng-container>
                            <ng-template #noViolence>No registra</ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef>Descripción</th>
                        <td mat-cell *matCellDef="let incidente">
                            {{ incidente.description }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="witnesses">
                        <th mat-header-cell *matHeaderCellDef>Testigo(s)</th>
                        <td mat-cell *matCellDef="let incident">
                            <ng-container
                                *ngIf="
                                    incident.witnesses?.length;
                                    else noWitness
                                "
                            >
                                <ul class="list-none p-0 m-0">
                                    <li *ngFor="let w of incident.witnesses">
                                        {{ w.identificationCode }} -
                                        {{ w.name }} {{ w.lastName }}
                                    </li>
                                </ul>
                            </ng-container>
                            <ng-template #noWitness>No registra</ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="location">
                        <th mat-header-cell *matHeaderCellDef>Ubicación</th>
                        <td mat-cell *matCellDef="let incident">
                            {{ incident.location?.city }}-{{
                                incident.address?.territory
                            }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="perpetror">
                        <th mat-header-cell *matHeaderCellDef>Victimario(s)</th>
                        <td mat-cell *matCellDef="let incident">
                            <ng-container
                                *ngIf="
                                    incident.perpetrors?.length;
                                    else noPerpetror
                                "
                            >
                                <ul class="list-none p-0 m-0">
                                    <li *ngFor="let p of incident.perpetrors">
                                        {{ p.identificationCode }} -
                                        {{ p.name }} {{ p.lastName }}
                                    </li>
                                </ul>
                            </ng-container>
                            <ng-template #noPerpetror>No registra</ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="victim">
                        <th mat-header-cell *matHeaderCellDef>Victima(s)</th>
                        <td mat-cell *matCellDef="let incident">
                            <ng-container
                                *ngIf="incident.victims?.length; else noVictim"
                            >
                                <ul class="list-none p-0 m-0">
                                    <li *ngFor="let v of incident.victims">
                                        {{ v.identificationCode }} -
                                        {{ v.name }} {{ v.lastName }}
                                    </li>
                                </ul>
                            </ng-container>
                            <ng-template #noVictim>No registra</ng-template>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: displayedColumns"
                    ></tr>
                </table>
            </div>
        </section>
        <br />
        <div>
            <button
                type="button"
                class="primary-button"
                (click)="createAccompaniment()"
            >
                <span class="button-content"
                    ><mat-icon>add_circle</mat-icon> Agregar nuevo</span
                >
            </button>
            <button
                class="secondary-button"
                [routerLink]="['/list-incident-madeja']"
            >
                <span class="button-content"
                    ><mat-icon>arrow_back</mat-icon> Atrás</span
                >
            </button>
        </div>

        <br />
        <section class="table-container mat-elevation-z1" tabindex="0">
            <div>
                <table
                    mat-table
                    [dataSource]="
                        accompanimentList
                            | paginate
                                : {
                                      id: 'server',
                                      itemsPerPage: limit,
                                      currentPage: page,
                                      totalItems: total,
                                  }
                    "
                >
                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef>Acciones</th>
                        <td mat-cell *matCellDef="let accompaniment">
                            <div class="action-buttons">
                                <a
                                    class="icon-button"
                                    (click)="editAccompaniment(accompaniment)"
                                >
                                    <mat-icon>edit</mat-icon>
                                </a>
                                <a
                                    class="icon-button"
                                    appOnlysuperuser="/incident/:id"
                                    (click)="
                                        deleteAccompaniment(accompaniment.id)
                                    "
                                >
                                    <mat-icon>delete</mat-icon>
                                </a>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef>ID</th>
                        <td mat-cell *matCellDef="let accompaniment">
                            {{ accompaniment.id }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef>Descripción</th>
                        <td mat-cell *matCellDef="let accompaniment">
                            {{ accompaniment.description }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef>Dirección</th>
                        <td mat-cell *matCellDef="let accompaniment">
                            {{ accompaniment.address }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="file">
                        <th mat-header-cell *matHeaderCellDef>Archivo</th>
                        <td mat-cell *matCellDef="let accompaniment">
                            <ng-container
                                *ngIf="hasFile(accompaniment); else noFile"
                            >
                                <a
                                    href
                                    (click)="
                                        openFile(accompaniment);
                                        $event.preventDefault()
                                    "
                                    style="
                                        cursor: pointer;
                                        text-decoration: underline;
                                    "
                                >
                                    {{ accompaniment.fileAttach.fileName }}
                                </a>
                            </ng-container>
                            <ng-template #noFile
                                ><span>No disponible</span></ng-template
                            >
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: showColumns"
                        class="highlight-row"
                    ></tr>
                </table>
            </div>
        </section>
        <pagination-controls
            (pageChange)="page = $event"
            previousLabel="Anterior"
            nextLabel="Siguiente"
            id="server"
        ></pagination-controls>
    </div>
</div>
